import { useState, useCallback } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import { motion } from "../../AuthNew/shared/motionUtils";
import {
  ModalTitle,
  ModalSubtitle,
  slideInRight,
} from "../shared/onboardingStyles";
import { CommonFlex } from "../../../styledComponents/common";
import { createNotification } from "../../../modules/notificationManager";
import { clearLocalStorage } from "../../../utils/handleLogout";

// Import invitation components
import InvitationCard from "./components/InvitationCard";

const CreateMyOwnButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.main.authGray};
  font-size: 13px;
  cursor: pointer;
  padding: 8px;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.main.authTextSecondary};
    text-decoration: underline;
  }
`;

const SignOutButton = styled(CreateMyOwnButton)``;

const Step1Invitation = ({
  pendingInvitation,
  userInfo,
  onJoinOrganization,
  onCreateOrganization,
  loginProfileCreatedReset,
}) => {
  const history = useHistory();
  const [errors, setErrors] = useState({});

  const handleInvitationAccept = useDebouncedCallback(
    (invitation) => {
      if (!invitation?.key) {
        createNotification(
          "error",
          "The invitation link is broken. Please contact your organization administrator for a new invitation link."
        );
        return;
      }

      // Navigate to accept invitation page
      history.push({
        pathname: "/accept-invitation",
        search: new URLSearchParams({
          key: invitation.key,
        }).toString(),
      });
    },
    3000,
    { leading: true, trailing: false }
  );

  const handleInvitationDecline = useCallback(() => {
    // User declines invitation - create organization path
    onCreateOrganization();
  }, [onCreateOrganization]);

  const handleSignOut = useCallback(() => {
    clearLocalStorage();
    history.push("/auth/login");
    if (loginProfileCreatedReset) {
      loginProfileCreatedReset();
    }
  }, [history, loginProfileCreatedReset]);

  return (
    <motion.div
      variants={slideInRight}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <ModalTitle>Hi {userInfo?.first_name}, You've been invited!</ModalTitle>
      <ModalSubtitle>
        Join your team and start your productivity journey
      </ModalSubtitle>

      <InvitationCard
        invitation={pendingInvitation}
        onAccept={handleInvitationAccept}
      />

      <CommonFlex
        justifyContent="center"
        margin="24px 0 0 0"
        gap="0"
        direction="column"
      >
        <CreateMyOwnButton onClick={() => handleInvitationDecline()}>
          Create My Own
        </CreateMyOwnButton>
        <SignOutButton onClick={handleSignOut}>Sign out</SignOutButton>
      </CommonFlex>
    </motion.div>
  );
};

export default Step1Invitation;
